<template lang="pug">
div.form-group.has-feedback
  label(:for="id") {{ label }}
  input.form-control.fld-date(
    :id="id"
    type="text"
    :aria-label="label"
    placeholder="dd-mm-aaaa"
    v-model="currentValue"
  )
  span.glyphicon.glyphicon-calendar.form-control-feedback
</template>
<script>
import { i18n } from '@/Infrastructure/Intl/Intl'

const jQuery = window.jQuery

export default ({
  name: 'DatePicker',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  computed: {
    currentLocale () {
      return i18n.locale
    }
  },
  watch: {
    currentLocale () {
      const input = document.querySelector('#' + this.id)
      const locale = this.currentLocale
      if (input !== null) {
        jQuery(input).data('DateTimePicker').locale(locale)
      }
    },
    value (newValue) {
      this.currentValue = newValue
    }
  },
  created () {
    this.currentValue = this.value
  },
  mounted () {
    this.buildDatepicker()
  },
  methods: {
    updateCurrentValue (updatedValue) {
      this.currentValue = updatedValue
      this.$emit('date-updated', this.currentValue)
    },
    buildDatepicker () {
      const updateValue = this.updateCurrentValue
      const input = document.querySelector('#' + this.id)
      const locale = this.currentLocale
      if (input !== null) {
        jQuery(input).datetimepicker({
          locale: locale,
          format: 'DD/MM/YYYY'
        })
        jQuery(input).on('dp.change', (event) => {
          updateValue(event.date.format('DD/MM/YYYY'))
        })
      }
    }
  }
})
</script>
